import React from 'react';
import './ScheduleAndUpdates.css';
import DailySchedule from './DailySchedule';
import TempleUpdates from './TempleUpdates';

function ScheduleAndUpdates() {
  return (
    <section className="schedule-updates section-padding">
      <div className="container">
        <div className="schedule-updates-grid">
          <div className="schedule-column">
            <DailySchedule />
          </div>
          <div className="updates-column">
            <TempleUpdates />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ScheduleAndUpdates;
